import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as stripeApi from '../Api/stripeApi';

const STRIPE_KEY = 'stripe';

export const useStripeConfig = () =>
	useQuery({
		queryKey: [STRIPE_KEY, 'config'],
		queryFn: () => stripeApi.fetchStripeConfig(),
	});

export const useCreatePaymentIntent = () => {
	return useMutation({
		mutationFn: ({
			amount,
			customerEmail,
			customerName,
			templateId,
			companyId,
		}) =>
			stripeApi.createPaymentIntent(
				amount,
				customerEmail,
				customerName,
				templateId,
				companyId,
			),
	});
};

export const usePurchasesByCompany = (companyId) =>
	useQuery({
		queryKey: [STRIPE_KEY, 'purchases', companyId],
		queryFn: () => stripeApi.getPurchasesByCompany(companyId),
		enabled: !!companyId,
	});

export const useStripePrice = (priceId) =>
	useQuery({
		queryKey: [STRIPE_KEY, 'price', priceId],
		queryFn: () => stripeApi.getStripePrice(priceId),
		enabled: !!priceId && priceId.startsWith('price_'),
	});

export const useStripePrices = (priceIds) =>
	useQuery({
		queryKey: [STRIPE_KEY, 'prices', priceIds],
		queryFn: () => stripeApi.getStripePrices(priceIds),
		enabled: !!priceIds && priceIds.length > 0,
	});
